// extracted by mini-css-extract-plugin
module.exports = {"card-left":"cardLeftRight_card-left__2tAda","card-right":"cardLeftRight_card-right__IU8oa"};